<template>
<div class="auth-layout row align-content--center">
  <div class="flex xs12 pa-3 flex-center">
    <router-link class="py-4 flex-center" to="/pano">
      <img src="../../assets/images/logo.png" height="85"/>
    </router-link>
  </div>

  <div class="flex xs12 pa-3">
    <div class="d-flex justify--center">
      <va-card class="auth-layout__card">
        <h2 class="display-5 text--center text--uppercase">{{ $t('auth.login') }}</h2>
        <va-separator/>
        <div class="pa-3">
          <form @submit.prevent="onsubmit" novalidate>
            <va-input
              v-model="form.email"
              type="email"
              :label="$t('auth.email')"
              :error="!!validationErrors.email.length"
              :error-messages="validationErrors.email"
              required
            />

            <va-input
              v-model="form.password"
              type="password"
              :label="$t('auth.password')"
              :error="!!validationErrors.password.length"
              :error-messages="validationErrors.password"
              required
            />

            <div class="d-flex justify--center mt-3">
              <va-button type="submit" class="my-0">{{ $t('auth.sign_in') }}</va-button>
            </div>
          </form>
        </div>
      </va-card>
    </div>
  </div>
</div>
</template>

<script>
import authServices from '../../services/api/auth'
import responseMixin from '../../services/api/response'
import helperMixin from '../../services/helper'
export default {
  name: 'AuthLayout',
  mixins: [responseMixin, helperMixin],
  data () {
    return {
      form: {
        email: '',
        password: '',
      },
      validationErrors: {
        email: [],
        password: []
      }
    }
  },
  computed: {
    formReady () {
      // return JSON.stringify(this.validationErrors) === JSON.stringify({})
      return !this.validationErrors.email.length && !this.validationErrors.password.length
    },
  },
  methods: {
    async postAuth() {
      const res = await authServices.post({
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('POST', 'error', res, '', 'Giriş');
        return ;
      }
      this.responseToast('POST', 'success', res, '', 'Giriş');

      if(res.data.data.api_token) {
        localStorage.setItem('admin_token', res.data.data.api_token);
        this.buttonAsHref('/pano');
      }
    },
    onsubmit () {
      this.validationErrors.email = this.form.email ? [] : ['E-posta adresi zorunlu alandır']
      this.validationErrors.password = this.form.password ? [] : ['Şifre zorunlu alandır']
      if (!this.formReady) {
        return
      }
      this.postAuth();
    },
  },
}
</script>

<style lang="scss">
.auth-layout {
  min-height: 100vh;
  background-image: linear-gradient(to right, #0e4ac4, #002c85);
  &__card {
    width: 100%;
    max-width: 600px;
  }
}
</style>